import {createContext} from "@lit/context";
import type {LDClient} from "launchdarkly-js-client-sdk";
import type {LDContext} from "launchdarkly-js-sdk-common";

export const LDClientContext =
  createContext<LDClientContextValue>("ldclient-context");

export interface LDClientContextValue {
  ldClient: LDClient;
  ldContext: LDContext;
}
